var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78679 8.7868C14.4129 3.16071 22.0435 8.53608e-07 30 0C37.9565 -8.53608e-07 45.5871 3.1607 51.2132 8.78679L30 30L8.78679 8.7868Z",
    fill: "url(#paint0_radial_8592_37124)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 36.6C33.5555 36.6 36.6 33.5555 36.6 29.8C36.6 26.0445 33.5555 23 29.8 23C26.0445 23 23 26.0445 23 29.8C23 33.5555 26.0445 36.6 29.8 36.6Z",
    fill: "#4B82FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.4C33.0879 24.4 35.6 26.9121 35.6 30C35.6 33.0879 33.0879 35.6 30 35.6C26.9121 35.6 24.4 33.0879 24.4 30C24.4 26.9121 26.9121 24.4 30 24.4ZM30 22C25.5818 22 22 25.5818 22 30C22 34.4182 25.5818 38 30 38C34.4182 38 38 34.4182 38 30C38 25.5818 34.4183 22 30 22Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8592_37124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30 30) rotate(90) scale(30)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B82FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B82FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassCustom);
export default __webpack_public_path__ + "static/media/compass_custom.f181cf7915107a8d1cdd3a2e88a3e18b.svg";
export { ForwardRef as ReactComponent };